var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('EditDiscountModule',{attrs:{"discountId":_vm.discountId,"detail":_vm.detail},on:{"editDetail":_vm.editDetail,"cancelEdit":_vm.cancelEdit,"newProductAdd":_vm.newProductAdd,"deleteTempItem":_vm.deleteTempItem,"deleteItem":_vm.deleteItem}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }